import { render, staticRenderFns } from "./IntOrderReview.vue?vue&type=template&id=77045718&scoped=true&"
import script from "./IntOrderReview.vue?vue&type=script&lang=js&"
export * from "./IntOrderReview.vue?vue&type=script&lang=js&"
import style0 from "./IntOrderReview.vue?vue&type=style&index=0&id=77045718&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77045718",
  null
  
)

export default component.exports